import { FC } from 'react'

import CONFIG from '../../../../config'
import { Layout } from '../../../containers'
import { Title, Text, Card, Button, Icon } from '../../../components/UI'

const RequestPage:FC = () => {
  return (
    <Layout menu titleMain={4}>
      <Title size="20" border className="lg:fz-18">Solicitudes</Title>

      <Text size="14" className="lg:fz-16 mt-30">Para realizar una solicitud presiona el botón en la sección que corresponda.</Text>

      <div className="row text-center mt-50 lg:mt-25">
        <div className="col-12 lg:col-6">
          <Card className="py-40 lg:py-50 px-20 h-full">
            <div style={{ minHeight: 25 }}>
              <Title component="h2" weight="bold">
                <Icon name="inquiries" className="d-block lg:d-inline-block align-middle mb-20 lg:mb-0 mr-10" />Consultas médicas
              </Title>
            </div>

            <div className="mt-40 mx-auto" style={{ maxWidth: 250 }}>
              <Button component="link" to={CONFIG.ROUTES.DASHBOARD.MEDICALAPPOINTMENTS.REQUESTDOCUMENTS} fullWidth>REALIZAR SOLICITUDES</Button>
            </div>
          </Card>
        </div>

        <div className="col-12 lg:col-6 mt-20 lg:mt-0">
          <Card className="py-40 lg:py-50 px-20 h-full">
            <div style={{ minHeight: 25 }}>
              <Title component="h2" weight="bold">Otras solicitudes</Title>
            </div>

            <div className="mt-40 mx-auto" style={{ maxWidth: 250 }}>
              <Button component="link" to={CONFIG.ROUTES.DASHBOARD.CONTACT} fullWidth>CONTÁCTANOS</Button>
            </div>
          </Card>
        </div>
      </div>
    </Layout>
  )
}

export { RequestPage }